export enum ProcessEnum {
  TOPUP = 'TOPUP',
  BUY_EXAM = 'BUY_EXAM',
  BUY_PRODUCTS = 'BUY_PRODUCTS',
  BUY_DAILY_LOGIN = 'BUY_DAILY_LOGIN',
  CHECK_IN_DAILY_LOGIN = 'CHECK_IN_DAILY_LOGIN',
  CHECK_IN_EXAM = 'CHECK_IN_EXAM',
  BUY_MEMBERSHIP = 'BUY_MEMBERSHIP',
  BUY_BUNDLE = 'BUY_BUNDLE'
}
